export const taskItem = {
	block: "taskItem",
};
